import React, { useEffect } from 'react';

export const useCloseOnBackdropClick = (
  ref: React.RefObject<Element>,
  onClose: () => void,
  disabled: boolean
) => {
  useEffect(() => {
    if (!disabled) {
      const handleClickOutside = (e: MouseEvent) => {
        if (ref.current && !ref.current.contains(e.target as Element)) {
          onClose();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [ref, disabled]);
};

export const useCloseOnEscapeKeyDown = (
  onClose: () => void,
  disabled: boolean
) => {
  const handleEscapeKeyDown = (e: KeyboardEvent) => {
    if ((e.charCode || e.keyCode) === 27) {
      onClose();
    }
  };
  useEffect(() => {
    if (!disabled) {
      document.body.addEventListener('keydown', handleEscapeKeyDown);
      return function cleanup() {
        document.body.removeEventListener('keydown', handleEscapeKeyDown);
      };
    }
  }, [disabled]);
};
